import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducer } from './bridge-485s.reducer';
import * as Bridge485sState from './bridge-485s.state';

@NgModule({
  imports: [StoreModule.forFeature(Bridge485sState.STATE_KEY, reducer)],
})
export class Bridge485sStateModule {}
